import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import { getTranslationConfig } from '@immediate_media/translation';

const geti18NextConfig = (siteKey) => {
  const config = getTranslationConfig(
    {
      siteKey,
      namespaces: ['patchwork'],
      fallback: 'en',
    },
    {
      useSuspense: false,
      interpolation: { escapeValue: false },
      compatibilityJSON: 'v3',
    },
  );

  i18n.use(initReactI18next);
  i18n.init(config);

  return i18n;
};

export default geti18NextConfig;
